import { useState } from 'react';

import AiTest from './AiTest';
import ClaudV2 from './claud_v2';

const AiDesign = () => {
  const [currentView, setCurrentView] = useState<
    'setup' | 'interview' | 'complete' | 'home' | 'written'
  >('home');
  return (
    <>
      {currentView === 'home' ? (
        <ClaudV2 setCurrentView={setCurrentView} />
      ) : (
        <AiTest setCurrentView={setCurrentView} currentView={currentView} />
      )}
    </>
  );
};

export default AiDesign;
